"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        paddingTop: 22,
        paddingRight: 22,
        paddingBottom: 22,
        paddingLeft: 22,
        margin: 0,
        fontSize: '22px',
        fontWeight: 400,
        lineHeight: '22px',
    },
    noPaddingBottom: {
        paddingBottom: 0,
    },
};
var getStyle = function (style, props) { return ([
    style.base,
    props.bgColor === styles_1.BackgroundColor.White && style.noPaddingBottom,
    {
        color: props.fontColor,
        backgroundColor: props.bgColor,
    },
]); };
var CardTitle = (function (_super) {
    __extends(CardTitle, _super);
    function CardTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardTitle.prototype.render = function () {
        var _a = this.props, style = _a.style, fontColor = _a.fontColor, bgColor = _a.bgColor, children = _a.children, others = __rest(_a, ["style", "fontColor", "bgColor", "children"]);
        return (React.createElement("h2", __assign({ style: getStyle(componentStyle, this.props) }, others), children));
    };
    CardTitle.defaultProps = {
        bgColor: styles_1.BackgroundColor.White,
        children: 'Title',
        fontColor: styles_1.FontColor.White,
    };
    CardTitle = __decorate([
        Radium
    ], CardTitle);
    return CardTitle;
}(react_1.PureComponent));
exports.CardTitle = CardTitle;



//////////////////
// WEBPACK FOOTER
// ./src/components/Card/CardTitle.tsx
// module id = 285
// module chunks = 0